import { getBrowserPreviewMimeType } from "@/helpers/fileType"

/** Opens a private attachment in a tab created by the user click, avoiding popup blockers. */
export async function openFilePreview(
  fileName: string,
  loadFile: () => Promise<Blob>,
  previewMimeType?: string
) {
  const mimeType = previewMimeType ?? getBrowserPreviewMimeType(fileName)
  if (!mimeType) return

  const newTab = window.open("about:blank", "_blank")
  if (newTab) {
    newTab.opener = null
  }

  try {
    const blob = await loadFile()
    if (!blob) {
      newTab?.close()
      return
    }

    const previewBlob = blob.type === mimeType ? blob : blob.slice(0, blob.size, mimeType)
    const blobUrl = URL.createObjectURL(previewBlob)

    if (newTab) {
      newTab.location.replace(blobUrl)
    } else {
      window.open(blobUrl, "_blank", "noopener")
    }

    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000)
  } catch {
    newTab?.close()
  }
}
